import { ChartOptions } from "chart.js";

export const groupedBarOptions: ChartOptions<"bar"> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top",
    },
    tooltip: {
      enabled: true,
    },
  },
  scales: {
    x: {
      stacked: false,
      grid: {
        display: false,
      },
    },
    y: {
      stacked: false,
      beginAtZero: true,
      ticks: {
        stepSize: 500,
      },
    },
  },
};
